import { useDispatch, useSelector } from 'react-redux'
import { useRef } from 'react'
import { useMemo } from 'react'

import InputBox from '../../../common/interactive/InputBox'
import classes from './LiabilityItem.module.css'
import { caseQuickUpdate } from '../../../../lib/fetchApi'
import { notificationActions } from '../../../../store/notifications'
import { stateOptions } from "../../../../lib/systemData"
import CheckboxCell from '../../../common/interactive/CheckboxCell'
import { caseActions } from '../../../../store/case'
import CustomSelect from '../../../common/interactive/CustomSelect'

const VehicleOwnerInfo = ({data, apiCase}) => {
    const dispatch = useDispatch()

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 
    const requestSequenceRef = useRef(0)
    const statesOptionsData = useMemo(() => stateOptions(), [])

    const updateHandler = async (data) => {
        let reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            fields: {
                [data.identifier.field] : data.data.value,
            }
        }

        setTimeout(() => {
            dispatch(caseActions.modifyActiveCase({
                folder: 'liabilities',
                item: {
                    itemId: data.identifier.type_id,
                    field: data.identifier.field,
                    value: data.data.value,
                },
            }))
        }, 0)

        const fieldKey = `${reqBody.type}:${reqBody.type_id}:${data.identifier.field}`
        const requestSequence = requestSequenceRef.current + 1
        requestSequenceRef.current = requestSequence

        let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody, null, null, {
            staleGuardKey: `${activeCase.case.id}:${fieldKey}`,
            staleGuardSequence: requestSequence,
        })

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        }       
        
    }

    const sameInfoAsDriverhandler = async (value) => {
        let reqBody = {
            type: apiCase,
            type_id: data.id,
            fields: {
                vehicle_owner_same_as_driver: value.data.value,
                vehicle_owner_address :  data.driver_address,
                vehicle_owner_city :  data.driver_city,
                vehicle_owner_name :  data.driver_name,
                vehicle_owner_state :  data.driver_state,
                vehicle_owner_zip :  data.driver_zip,
            }    
        }
      
        if (value.data.value) { // if is checked, than also change the other info

            let fields = []
            for (const [key, value] of Object.entries(reqBody.fields)) {               
                fields.push({
                    field: key,
                    value: value
                })
            }            

            const dispatchBody = {
                folder: 'liabilities',
                item: {
                    itemId: data.id,
                    fields: fields                
                },
            }

            setTimeout(() => {
                dispatch(caseActions.modifyActiveCaseMultiple(dispatchBody))
            }, 0)

            const requestSequence = requestSequenceRef.current + 1
            requestSequenceRef.current = requestSequence
            let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody, null, null, {
                staleGuardKey: `${activeCase.case.id}:${apiCase}:${data.id}:vehicle_owner_same_as_driver`,
                staleGuardSequence: requestSequence,
            })

            if (update && update.errorMessage) {
                dispatch(notificationActions.setError(update))
            } 
            
        } else { // if it is not checked, than only change "vehicle_owner_same_as_driver"
            reqBody = {
                type: apiCase,
                type_id: data.id,
                fields: {
                    vehicle_owner_same_as_driver: false,
                    vehicle_owner_address :  null,
                    vehicle_owner_city :  null,
                    vehicle_owner_name :  null,
                    vehicle_owner_state :  null,
                    vehicle_owner_zip :  null,
                }    
            }
            let fields = []
            for (const [key, value] of Object.entries(reqBody.fields)) {               
                fields.push({
                    field: key,
                    value: value
                })
            }            

            const dispatchBody = {
                folder: 'liabilities',
                item: {
                    itemId: data.id,
                    fields: fields                
                },
            }

            setTimeout(() => {
                dispatch(caseActions.modifyActiveCaseMultiple(dispatchBody))
            }, 0)

            const requestSequence = requestSequenceRef.current + 1
            requestSequenceRef.current = requestSequence
            let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody, null, null, {
                staleGuardKey: `${activeCase.case.id}:${apiCase}:${data.id}:vehicle_owner_same_as_driver`,
                staleGuardSequence: requestSequence,
            })

            if (update && update.errorMessage) {
                dispatch(notificationActions.setError(update))
            } 
        }
    }

    return <div className="flex-container">
        <div className={classes.title_width}>
            <h5 >Vehicle Owner Info</h5>
            <CheckboxCell label={'Same Information as Driver'} direction={'reverse'} action={sameInfoAsDriverhandler} checked={data.vehicle_owner_same_as_driver} identifier={{type: apiCase}}/>
        </div>
        {!data.vehicle_owner_same_as_driver && <div className="flex-container-equal gap-8">                                
            <InputBox label={'Name'} type={'text'} currentValue={data.vehicle_owner_name} action={updateHandler} identifier={{type: apiCase, field: 'vehicle_owner_name', type_id: data.id}} maxWidth={180}/>
            <InputBox label={'Address'} type={'text'} currentValue={data.vehicle_owner_address} action={updateHandler} identifier={{type: apiCase, field: 'vehicle_owner_address', type_id: data.id}} maxWidth={180}/>
            <div className="flex-container-equal">
                <InputBox label={'City'} type={'text'} currentValue={data.vehicle_owner_city} action={updateHandler} identifier={{type: apiCase, field: 'vehicle_owner_city', type_id: data.id}} minWidth={130}/>
                <CustomSelect action={updateHandler} label={'State'} optionsData={statesOptionsData} preSelectedValue={data.vehicle_owner_state}  identifier={{type: apiCase, field: 'vehicle_owner_state', type_id: data.id, folder: 'liabilities'}} hasRemove={true}/>
                <InputBox label={'Postcode'} type={'text'} currentValue={data.vehicle_owner_zip} action={updateHandler} identifier={{type: apiCase, field: 'vehicle_owner_zip', type_id: data.id}} format={'zip'}/>
            </div>
        </div>}
    </div>
}

export default VehicleOwnerInfo